import {GET_DAILY_ACTIVITY_STARTED} from "../../reducers/dailyActivityReducer";


export const getDailyActivityStarted = () =>{
    return {
        type: GET_DAILY_ACTIVITY_STARTED,
        payload: {}
    }
}